import { render, staticRenderFns } from "./RglFileManage.vue?vue&type=template&id=79e75c88&scoped=true"
import script from "./RglFileManage.vue?vue&type=script&lang=js"
export * from "./RglFileManage.vue?vue&type=script&lang=js"
import style0 from "./RglFileManage.vue?vue&type=style&index=0&id=79e75c88&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e75c88",
  null
  
)

export default component.exports